import React from 'react';
import Header from '../../components/Header';
import MainScene from '../../components/MainScene';
import Footer from '../../components/Footer';
import BackgroundScene from '../../components/BackgroundScene';
import SEO from '../../components/SEO';
import styles from './Home.module.css';

interface HomeProps {}

const Home: React.FC<HomeProps> = () => {
  return (
    <div className={styles.home}>
      <SEO 
        title="Rythm - Discord Music Bot Made for Listening Together"
        description="The music app designed to be used together. Rythm makes it possible to share, discover and enjoy music with friends from all around the world."
        keywords="rythm bot, discord music bot, play music on discord, listen with friends, music streaming discord, music bot 2025, group listening, best discord music bot, rythm music app, playlist discord"
        canonicalUrl="https://rythm.fm/"
        schemaType="SoftwareApplication"
      />
      <BackgroundScene modelScale={2.0} />
      <Header />
      <main className={styles.mainContent}>
        <MainScene />
        {/* Add additional sections here if needed */}
      </main>
      <Footer />
    </div>
  );
};

export default Home; 